<template>
  <div class="park">
    <div class="park-btn">
        <div class="test-input">
            <el-input v-model="collect.courseId"></el-input> 
        </div>
        <div class="test-input">
            <el-input v-model="collect.status"></el-input> 
        </div>
        <el-button type="primary" size="mini" @click="collectCourse()">收藏课程</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="getMyCollectCourses()">我收藏的课程</el-button>
    </div>
    <div class="park-btn">
        <div class="test-input">
            <el-input v-model="jobcollect.jobId"></el-input> 
        </div>
        <div class="test-input">
            <el-input v-model="jobcollect.status"></el-input> 
        </div>
        <el-button type="primary" size="mini" @click="collectJob()">收藏岗位</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="getMyCollectJobs()">我收藏的岗位</el-button>
    </div>
    <div class="park-btn">
        <div class="test-input">
            <el-input v-model="universitycollect.universityId"></el-input> 
        </div>
        <div class="test-input">
            <el-input v-model="universitycollect.status"></el-input> 
        </div>
        <el-button type="primary" size="mini" @click="collectUniversity()">收藏学校</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="getMyCollectUniversitys()">我收藏的学校</el-button>
    </div>
     <div class="park-btn">
        <div class="test-input">
            <el-input v-model="personcollect.personId"></el-input> 
        </div>
        <div class="test-input">
            <el-input v-model="personcollect.status"></el-input> 
        </div>
        <el-button type="primary" size="mini" @click="collectPerson()">收藏人物</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="getMyCollectPersons()">我收藏的人物</el-button>
    </div>
    <div class="park-btn">
        <div class="test-input">
            <el-input v-model="course.id"></el-input> 
        </div>
        <el-button type="primary" size="mini" @click="getDetailSeries()">查看系列详情+课程计数</el-button>
        <el-button type="primary" size="mini" @click="scoreCourse()">课程打分</el-button>
        <el-button type="primary" size="mini" @click="getDetailCourse()">查看课程详情+课程计数</el-button>
        <el-button type="primary" size="mini" @click="viewVideo()">观看视频</el-button>
        <el-button type="primary" size="mini" @click="getDetailUniversity()">查看学校详情+课程计数</el-button>
        <el-button type="primary" size="mini" @click="getDetailPerson()">查看人物详情+课程计数</el-button>
        <el-button type="primary" size="mini" @click="getDetailJob()">查看岗位详情+课程计数</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="getMyViewCourses()">我看过的课程列表</el-button>
    </div>
    <div class="park-btn">
        <div class="test-input">
            <el-input v-model="courseNote.videoId"></el-input> 
        </div>
        <div class="test-input">
            <el-input v-model="courseNote.content"></el-input> 
        </div>
        <el-button type="primary" size="mini" @click="addNote()">添加我的课程笔记</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="getNote()">查看我的课程笔记</el-button>
        <el-button type="primary" size="mini" @click="getNotes()">查看我的所有课程笔记</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="addQuestion()">添加问题</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="getQuestionList()">获取问题列表</el-button>
    </div>
    <div class="park-btn">
        <div class="test-input">
            <el-input v-model="question.questionId"></el-input> 
        </div>
        <el-button type="primary" size="mini" @click="getQuestionDetail()">获取问题详情</el-button>
         <el-button type="primary" size="mini" @click="answerQuestion()">回答问题</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="enrollCompetition">报名竞赛</el-button>
        <el-button type="primary" size="mini" @click="getEntry">获取作品详情</el-button>
        <el-button type="primary" size="mini" @click="getMyEntry">获取我的作品</el-button>
        <el-button type="primary" size="mini" @click="voteCompetition">投票作品</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="getMySystemMessages">获取我的系统消息</el-button>
        <el-button type="primary" size="mini" @click="getMySystemMessage">获取系统消息详情</el-button>
        <el-button type="primary" size="mini" @click="getMySystemMessageCount">获取系统消息数量</el-button>
        <el-button type="primary" size="mini" @click="getMyScore">获取我的积分</el-button>
         <el-button type="primary" size="mini" @click="likeNews()">点赞新闻</el-button>
          <el-button type="primary" size="mini" @click="collectNews()">收藏新闻</el-button>
          <el-button type="primary" size="mini" @click="getMyLikeNews()">获取我喜欢的新闻</el-button>
          <el-button type="primary" size="mini" @click="getMyCollectNews()">获取我收藏的新闻</el-button>
          <el-button type="primary" size="mini" @click="getUserInfo()">获取用户信息</el-button>
          <el-button type="primary" size="mini" @click="updateUserInfo()">更新用户信息</el-button>
    </div>
     <div class="park-btn">
        <el-button type="primary" size="mini" @click="addUserAction">添加用户行为</el-button>
        <el-button type="primary" size="mini" @click="addStatistics">添加用户统计</el-button>
        <el-button type="primary" size="mini" @click="addStatisticsCity">添加统计城市</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="addRecommendNews">添加新闻推荐</el-button>
        <el-button type="primary" size="mini" @click="getRecommendNews">获取新闻推荐</el-button>
        <el-button type="primary" size="mini" @click="getRelationNews">获取新闻相关</el-button>
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="addRecommendJobs">添加岗位推荐</el-button>
        <el-button type="primary" size="mini" @click="getRecommendJobs">获取岗位推荐</el-button>
        
    </div>
    <div class="park-btn">
        <el-button type="primary" size="mini" @click="addRecommendCourses">添加课程推荐</el-button>
        <el-button type="primary" size="mini" @click="getRecommendCourses">获取课程推荐</el-button>
        <el-button type="primary" size="mini" @click="getRelationCourses">获取课程相关推荐</el-button>
    </div>
     <div class="park-btn">
        <el-button type="primary" size="mini" @click="collectArticle">收藏杂志文章</el-button>
        <el-button type="primary" size="mini" @click="getArticleList">获取杂志文章列表</el-button>
        <el-button type="primary" size="mini" @click="getArticle">获取杂志文章详情</el-button>
        <el-button type="primary" size="mini" @click="getMagazine">获取杂志详情</el-button>
    </div>
    <div>
        Result:{{result}}
    </div>
     
  </div>
</template>

<script>
import gql from "graphql-tag";
import { collectMagazineArticle, getMagazineArticles,getMagazineArticle,getMagazine } from './test.gql';
export default {
  name: 'dic',
  data () {
    return {
        collect: {
            courseId:'5',
            status:'1'
        },
        jobcollect: {
            jobId:'5',
            status:'1'
        },
        universitycollect: {
            universityId:'5',
            status:'1'
        },
        course:{
            id:"3"
        },
        personcollect: {
            personId:'5',
            status:'1'
        },
        courseNote: {
            videoId:5,
            content:''
        },
        question: {
            questionId:5,
        },
        result:null,
      dicEntity:{
        name:null,
        method:null,
      },
      dicList:null,
      dataArgs:{
        take:20,
        skip:0,
        order:'-createTime',
        count:null,
      },
      isUpdateShow:false,
      isDeleteShow:false,
    }
  },
  created(){

  },
  methods:{
      addUserAction(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: UserActionInput!) {
            addUserActions(data:$data) {
              status
            }
          }`,
        variables: {data:{user:'',data:[{type:'',content:'',context:''}]}},
        }).then((res) => {
            this.result = res.data.addUserActions
        })
      },
      addStatistics(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: [StatisticNumsInput!]!) {
            addStatistics(data:$data) {
              status
            }
          }`,
        variables: {data:[{nums:'23',name:'News',type:'AddResources',site:'WUPEN',currentDay:new Date()}]},
        }).then((res) => {
            this.result = res.data.addStatistics
        })
      },
      addStatisticsCity(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: [StatisticCityInput!]!) {
            addStatisticCity(data:$data) {
              status
            }
          }`,
        variables: {data:[{city:'Shanghai',lng:'1',lat:'1',country:'China',continent:'Asia'}]},
        }).then((res) => {
            this.result = res.data.addStatisticCity
        })
      },
      addRecommendNews(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: [RecommendNews!]!) {
            addRecommendNews(data:$data) {
              status
            }
          }`,
        variables: {data:[{'userId': 'normal', 'newsId': '12632'}, {'userId': 'normal', 'newsId': '13054'}, {'userId': 'normal', 'newsId': '12633'}, {'userId': 'normal', 'newsId': '12631'}, {'userId': 'normal', 'newsId': '12627'}, {'userId': 'normal', 'newsId': '11555'}, {'userId': 'normal', 'newsId': '12614'}, {'userId': 'normal', 'newsId': '12708'}, {'userId': 'normal', 'newsId': '12706'}, {'userId': 'normal', 'newsId': '13007'}]},
        }).then((res) => {
            this.result = res.data.addRecommendNews
        })
      },
      getRelationNews(){
          this.$global.GraphqlQuery(this,{
          query: gql`query ($order: String, $skip: Int = 0, $take: Int, $newsId: String!) {
            getRelationNews(order: $order, skip: $skip, take: $take, newsId:$newsId){
              status,
              data {
                  id
              },
              total
            }
          }`,
            variables: {newsId:'13040'},
            }).then((res) => {
                this.result = res.data.getRelationNews
            })
      },
      getRecommendNews(){
          this.$global.GraphqlQuery(this,{
          query: gql`query ($order: String, $skip: Int = 0, $take: Int) {
            getRecommendNews(order: $order, skip: $skip, take: $take){
              status,
              data {
                  id
              },
              total
            }
          }`,
        variables: {},
        }).then((res) => {
            this.result = res.data.getRecommendNews
        })
      },
      viewVideo(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($id: String!) {
            viewCourseVideo(id:$id) {
              status 
            }
          }`,
        variables: {id:'43'},
        }).then((res) => {
            this.result = res.data.viewCourseVideo
        })
      },
      addRecommendJobs(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: [RecommendJob!]!) {
            addRecommendJobs(data:$data) {
              status
            }
          }`,
        variables: {data:[{userId:'dfb7d0d0-f143-11ea-9f63-8bbcf68ac8e0',jobId:'100'},{userId:'dfb7d0d0-f143-11ea-9f63-8bbcf68ac8e0',jobId:'99'}]},
        }).then((res) => {
            this.result = res.data.addRecommendJobs
        })
      },
      getArticleList(){
          this.$global.GraphqlQuery(this,
          getMagazineArticles,

        null).then((res) => {
            this.result = res.data
        })
      },
      getArticle(){
          this.$global.GraphqlQuery(this,
          getMagazineArticle,
          {id:'598'}).then((res) => {
            this.result = res.data
        })
      },
      getMagazine(){
          this.$global.GraphqlQuery(this,
          getMagazine,
          {id:'2'}).then((res) => {
            this.result = res.data
        })
      },
      getRecommendJobs(){
          this.$global.GraphqlQuery(this,{
          query: gql`query ($order: String, $skip: Int = 0, $take: Int) {
            getRecommendJobs(order: $order, skip: $skip, take: $take){
              status,
              data {
                  id
              },
              total
            }
          }`,
        variables: {},
        }).then((res) => {
            this.result = res.data.getRecommendJobs
        })
      },
      addRecommendCourses(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: [RecommendCourse!]!) {
            addRecommendCourses(data:$data) {
              status
            }
          }`,
        variables: {data:[{userId:'dfb7d0d0-f143-11ea-9f63-8bbcf68ac8e0',courseId:'168'},{userId:'dfb7d0d0-f143-11ea-9f63-8bbcf68ac8e0',courseId:'98'}]},
        }).then((res) => {
            this.result = res.data.addRecommendCourses
        })
      },
      getRelationCourses(){
          this.$global.GraphqlQuery(this,{
          query: gql`query ($order: String, $skip: Int = 0, $take: Int, $courseId: String!) {
            getRelationCourses(order: $order, skip: $skip, take: $take, courseId: $courseId){
              status,
              data {
                  id
              },
              total
            }
          }`,
        variables: {courseId: '139'},
        }).then((res) => {
            this.result = res.data.getRelationCourses
        })
      },
      getRecommendCourses(){
          this.$global.GraphqlQuery(this,{
          query: gql`query ($order: String, $skip: Int = 0, $take: Int) {
            getRecommendCourses(order: $order, skip: $skip, take: $take){
              status,
              data {
                  id
              },
              total
            }
          }`,
        variables: {},
        }).then((res) => {
            this.result = res.data.getRecommendCourses
        })
      },
      getMySystemMessageCount(){
          this.$global.GraphqlQuery(this,{
                query: gql`query getMySystemMessagesCount($isRead: Int = -1) {
                getMySystemMessagesCount(isRead: $isRead){
                    status,
                    data,
                    total
                }
                }`,
                // Parameters
                variables: {isRead:-1},
            }).then((res) => {
                this.result = res.data.getMySystemMessagesCount
            })
      },
      getMySystemMessages(){
          this.$global.GraphqlQuery(this,{
                query: gql`query getMySystemMessages($order: String, $skip: Int = 0, $take: Int, $isRead: Int = -1) {
                getMySystemMessages(order: $order, skip: $skip, take: $take, isRead: $isRead){
                    status,
                    data {
                        id,content,title,userId,data,isRead
                    },
                    total
                }
                }`,
                // Parameters
                variables: {isRead:0},
            }).then((res) => {
                this.result = res.data.getMySystemMessages
            })
      },
      getMySystemMessage(){
          this.$global.GraphqlQuery(this,{
                query: gql`query getMySystemMessage($id: String!) {
                getMySystemMessage(id: $id){
                    status,
                    data {
                        id,content,title,userId,data,isRead
                    },
                    total
                }
                }`,
                // Parameters
                variables: {id:'5'},
            }).then((res) => {
                this.result = res.data.getMySystemMessage
            })
      },
      voteCompetition(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($id: String!) {
            voteEntry(id:$id) {
              status
            }
          }`,
            variables: {id:'testtt'},
            }).then((res) => {
                this.result = res.data.voteEntry
            })
      },
      getMyEntry(){
          this.$global.GraphqlQuery(this,{
                query: gql`query getMyEntries($order: String, $skip: Int = 0, $take: Int, $status: Int=1, $keywords: String) {
                getMyEntries(order: $order, skip: $skip, take: $take, status: $status, keywords: $keywords){
                    status,
                    data {
                        id,isLike,likeNum,pdfs,images,videos,leader{
                            id,name
                        },teammates {
                            id,name
                        },tags {
                            id,name
                        },competition {
                            id, name
                        }
                    }
                }
                }`,
                // Parameters
                
            }).then((res) => {
                this.result = res.data.getMyEntries
            })
      },
      getEntry(){
          this.$global.GraphqlQuery(this,{
                query: gql`query getEntry($id: String!) {
                getEntry(id: $id){
                    status,
                    data {
                        id,isLike,likeNum,pdfs,images,videos,leader{
                            id,name
                        },teammates {
                            id,name
                        },tags {
                            id,name
                        },competition {
                            id, name
                        }
                    }
                }
                }`,
                // Parameters
                variables: {id:'re0016'},
            }).then((res) => {
                this.result = res.data.getEntry
            })
      },
      enrollCompetition(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: EntryEnroll!) {
            enrollCompetition(data:$data) {
              status
            }
          }`,
            variables: {data:{competitionId:5, 
                leader:{name:'田程元',username:'dashtom4',infoSrc:'http://58.33.91.82:12404/wupen-test/images/45cb3250-e9d2-11ea-9fb6-01b3d4be3734.jpg'},
                teammates:[],
                teamname:'led',
                }},
            }).then((res) => {
                this.result = res.data.enrollCompetition
            })
      },
      addNote(){
          this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: CourseNoteInput!) {
            updateMyCourseNote(data:$data) {
              status
            }
          }`,
            variables: {data:{videoId:parseInt(this.courseNote.videoId), content:this.courseNote.content}},
            }).then((res) => {
             this.result = res.data.updateMyCourseNote
            })
      },
      getNotes(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyCourseNotes($order: String, $skip: Int = 0, $take: Int) {
            getMyCourseNotes(order: $order, skip: $skip, take: $take){
                status,
                total,
                data {
                videoId,
                content,
                userId,
                
                video {
                    course {
                        id
                        category {
                            id,name
                        },
                        teacher {
                            id,name,university {
                                id,name
                            }
                        }
                    }
                }
                },
            }
            }`,
            // Parameters
            variables: {},
        }).then((res) => {
            this.result = res.data.getMyCourseNotes
        })
      },
      getNote(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyCourseNote($videoId: String!) {
            getMyCourseNote(videoId: $videoId){
                status,
                total,
                data {
                videoId,
                content,
                userId
                }
            }
            }`,
            // Parameters
            variables: {videoId:this.courseNote.videoId},
        }).then((res) => {
            this.result = res.data.getMyCourseNote
        })
    },
    likeNews(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($newsId:String! ,$status: String!) {
            likeNews(newsId:$newsId, status: $status) {
              status
            }
          }`,
        variables: {newsId:'642',status:'1'},
        }).then((res) => {
            this.result = res.data.likeNews
        })
    },
    updateUserInfo(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data:UserInfoInput!) {
            updateUserInfo( data: $data) {
              status
            }
          }`,
        variables: {data:{birthday:new Date(),location:'1234'}},
        }).then((res) => {
            this.result = res.data.updateUserInfo
        })
    },
    getUserInfo(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`query{
            getUserInfo{
              status,
              data {
                  birthday
              }
            }
          }`,
        
        }).then((res) => {
            this.result = res.data.getUserInfo
        })
    },
    collectNews(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($newsId:String! ,$status: String!) {
            collectNews(newsId:$newsId, status: $status) {
              status
            }
          }`,
        variables: {newsId:'2537',status:'1'},
        }).then((res) => {
            this.result = res.data.collectNews
        })
    },
    collectArticle(){
        this.$global.GraphqlMutation(this,collectMagazineArticle,{articleId:'598',status:'1'}).then((res) => {
            this.result = res.data
        })
    },
    collectCourse(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($courseId:String! ,$status: String!) {
            collectCourse(courseId:$courseId, status: $status) {
              status
            }
          }`,
        variables: this.collect,
        }).then((res) => {
            this.result = res.data.collectCourse
        })
    },
    getMyCollectNews(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyCollectNewses($order: String, $skip: Int = 0, $take: Int) {
            getMyCollectNewses(order: $order, skip: $skip, take: $take){
                status,
                total,
                data {
                id,
                
                }
            }
            }`,
            // Parameters
            variables: {},
        }).then((res) => {
            this.result = res.data.getMyCollectNewses
        })
    },
    getMyLikeNews(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyLikeNewses($order: String, $skip: Int = 0, $take: Int) {
            getMyLikeNewses(order: $order, skip: $skip, take: $take){
                status,
                total,
                data {
                id,
                
                }
            }
            }`,
            // Parameters
            variables: {},
        }).then((res) => {
            this.result = res.data.getMyLikeNewses
        })
    },
    getDetailUniversity(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getUniversity($id: String!) {
            getUniversity(id: $id){
                status,
                total,
                data {
                id,
                isCollect,
                city {
                    id
                },
                continent {
                    id
                },
                country {
                    id
                }
                }
            }
            }`,
            // Parameters
            variables: {id:this.course.id},
        }).then((res) => {
            this.result = res.data.getUniversity
        })
    },
    getDetailPerson(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getPerson($id: String!) {
            getPerson(id: $id){
                status,
                total,
                data {
                id,
                isCollect,
                college {
                    id
                },
                title {
                    id
                },
                university {
                    id
                }
                }
            }
            }`,
            // Parameters
            variables: {id:this.course.id},
        }).then((res) => {
            this.result = res.data.getPerson
        })
    },
    getDetailSeries(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getSeries($id: String!) {
            getSeries(id: $id){
                status,
                total,
                data {
                id,
                persons {
                    id,
                    name,
                    university {
                        id,
                        name
                    }
                }
                }
            }
            }`,
            // Parameters
            variables: {id:'8'},
        }).then((res) => {
            this.result = res.data.getSeries
        })
    },
    getDetailJob(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getJob($id: String!) {
            getJob(id: $id){
                status,
                total,
                data {
                id,
                isCollect,
                region {
                    id
                },
                secondRegion {
                    id
                },
                thirdRegion {
                    id
                },
                industry {
                    id
                },
                position {
                    id
                },
                secondPosition {
                    id
                }
                }
            }
            }`,
            // Parameters
            variables: {id:this.course.id},
        }).then((res) => {
            this.result = res.data.getJob
        })
    },
    scoreCourse(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($courseId:String! ,$score: Float!) {
            scoreCourse(courseId:$courseId, score: $score) {
              status
            }
          }`,
        variables: {courseId:'23',score:4.5},
        }).then((res) => {
            this.result = res.data.scoreCourse
        })
    },

    getMyScore(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyScore {
            getMyScore{
                status,
                total,
                data {
                    todayScore,
                }
            }
            }`,
            // Parameters[]
        }).then((res) => {
            this.result = res.data.getMyScore
        })
    },
    getDetailCourse(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getCourse($id: String!) {
            getCourse(id: $id){
                status,
                total,
                data {
                id,
                isCollect,
                participants,
                process,
                isScore,
                teacher {
                    id
                },
                category {
                    id
                },
                secondCategory {
                    id
                },
                videos {
                    id,
                    title,
                    intro,
                    video
                }
                }
            }
            }`,
            // Parameters
            variables: {id:this.course.id},
        }).then((res) => {
            this.result = res.data.getCourse
        })
    },
    getMyCollectCourses(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyCollectCourses($order: String, $skip: Int = 0, $take: Int) {
            getMyCollectCourses(order: $order, skip: $skip, take: $take){
                status,
                total,
                data {
                id,
                
                }
            }
            }`,
            // Parameters
            variables: {},
        }).then((res) => {
            this.result = res.data.getMyCollectCourses
        })
    },
    getMyViewCourses(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyViewCourses($order: String, $skip: Int = 0, $take: Int) {
            getMyViewCourses(order: $order, skip: $skip, take: $take){
                status,
                total,
                data {
                    id,
                    createTime
                }
            }
            }`,
            // Parameters
            variables: {},
        }).then((res) => {
            this.result = res.data.getMyViewCourses
        })
    },
    collectJob(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($jobId:String! ,$status: String!) {
            collectJob(jobId:$jobId, status: $status) {
              status
            }
          }`,
        variables: this.jobcollect,
        }).then((res) => {
            this.result = res.data.collectJob
        })
    },
    
    getMyCollectJobs(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyCollectJobs($order: String, $skip: Int = 0, $take: Int) {
            getMyCollectJobs(order: $order, skip: $skip, take: $take){
                status,
                total,
                data {
                id,
                
                }
            }
            }`,
            // Parameters
            variables: {},
        }).then((res) => {
            this.result = res.data.getMyCollectJobs
        })
    },
    collectUniversity(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($universityId:String! ,$status: String!) {
            collectUniversity(universityId:$universityId, status: $status) {
              status
            }
          }`,
        variables: this.universitycollect,
        }).then((res) => {
            this.result = res.data.collectUniversity
        })
    },
    getMyCollectUniversitys(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyCollectUniversities($order: String, $skip: Int = 0, $take: Int) {
            getMyCollectUniversities(order: $order, skip: $skip, take: $take){
                status,
                total,
                data {
                id,
                
                }
            }
            }`,
            // Parameters
            variables: {},
        }).then((res) => {
            this.result = res.data.getMyCollectUniversities
        })
    },
    collectPerson(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($personId:String! ,$status: String!) {
            collectPerson(personId:$personId, status: $status) {
              status
            }
          }`,
        variables: this.personcollect,
        }).then((res) => {
            this.result = res.data.collectPerson
        })
    },
    
    getMyCollectPersons(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getMyCollectPersons($order: String, $skip: Int = 0, $take: Int) {
            getMyCollectPersons(order: $order, skip: $skip, take: $take){
                status,
                total,
                data {
                id,
                
                }
            }
            }`,
            // Parameters
            variables: {},
        }).then((res) => {
            this.result = res.data.getMyCollectPersons
        })
    },
    collectJob(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($jobId:String! ,$status: String!) {
            collectJob(jobId:$jobId, status: $status) {
              status
            }
          }`,
        variables: this.jobcollect,
        }).then((res) => {
            this.result = res.data.collectJob
        })
    },
    addQuestion(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: QuestionInput!) {
            addQuestion(data: $data) {
              status
            }
          }`,
        variables: {data :{content:'我可不以吃饭了么？'}},
        }).then((res) => {
            this.result = res.data.addQuestion
        })
    },
    answerQuestion(){
        this.$global.GraphqlMutation(this,{
          mutation: gql`mutation ($data: QuestionAnswerInput!) {
            addQuestionAnswer(data: $data) {
              status
            }
          }`,
        variables: {data :{questionId:12,content:'可以'}},
        }).then((res) => {
            this.result = res.data.addQuestionAnswer
        })
    },
    getQuestionList(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getQuestions($order: String, $skip: Int = 0, $take: Int, $content: String) {
            getQuestions(order: $order, skip: $skip, take: $take, content: $content){
                status,
                total,
                data {
                id,
                user {
                    id,
                    username,
                },
                content,
                answers {
                    id,
                    user {
                        id,
                        username
                    }
                }
                },
                
            }
            }`,
            // Parameters
            variables: {content:'不以'},
        }).then((res) => {
            this.result = res.data.getQuestions
        })
    },
    getQuestionDetail(){
        this.$global.GraphqlQuery(this,{
            query: gql`query getQuestion($id: String!) {
            getQuestion(id: $id){
                status,
                total,
                data {
                id,
                content,
                answers {
                    id,
                    content,
                    userId,
                    user{
                        id,
                        username,
                        firstName,
                        lastName
                    }
                },
                userId,
                user {
                    id,
                    username,
                    firstName,
                }
                
                }
            }
            }`,
            // Parameters
            variables: {id: this.question.questionId},
        }).then((res) => {
            this.result = res.data.getQuestion
        })
    },
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.test-input {
    display:inline-block;
    width:200px;
}
.park{
  height: 100%;
}
.park-btn {
  margin: 10px;
}
.park-red {
  background-color: red;
  color:white;
  padding:5px;
}
.park-green{
  background-color: green;
  color: white;
  padding:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/configuration/Test.vue